<div *ngIf="view" class="scaffold-view-panel" [ngClass]="{'show-properties':movingItem.propertiesItem, 'is-saving':isSaving}">
  <div class="processing-state" *ngIf="trackUpdates && updateStatusService.processingStatus && false" [ngClass]="{'processing' : updateStatusService.processingStatus == 'PROCESSING', 'processing-completed' : updateStatusService.processingStatus == 'COMPLETED', 'processing-error' : updateStatusService.processingError}">
    <span *ngIf="updateStatusService.processingStatus == 'PROCESSING'" [nbSpinner]="loading" nbSpinnerStatus="danger">{{'processing'|translation}} &nbsp;&nbsp;</span>
    <span *ngIf="updateStatusService.processingStatus == 'COMPLETED'"> {{updateStatusService.processingMessage}} </span>
  </div>
  <div class="breadcrumb-holder" *ngIf="showEdit">
    <span>
      <a routerLink="/data-models/{{view?.type}}">{{view?.type|friendlyType}}</a>
      <span class="breadcrumb-seperator"> <i class="fas fa-chevron-right" style="font-size:10px;"></i> </span>
      <span>{{view?.title || view?.mode}}</span>
    </span>
  </div>
  <p *ngIf="checkKeys(view_data) && showEdit" style="color:red;">{{'preview_changes_not_save_lingo'|translation}}.</p>
  <div class="child-note" *ngIf="view.clone_from && !view.clone_from.seperate_clone">This item is updated from <a href="/{{view.clone_from.type}}/{{view.clone_from.id}}" target="_blank">{{view.clone_from.title}}</a>, last updated {{view.clone_from.updated_at|date:'medium'}}</div>
  <div class="child-note" *ngIf="view.clone_from && view.clone_from.seperate_clone">This item has deviated from original master <a href="/{{view.clone_from.type}}/{{view.clone_from.id}}" target="_blank">{{view.clone_from.title}}</a>, seperated on {{view.clone_from.seperate_clone|date:'medium'}}</div>
  <div class="scaffold-page-buttons" *ngIf="isRoot && !iframeService?.isInIframe">
    <!--button nbButton status="primary" *ngIf="checkKeys(view_data)" (click)='logEdits()'>Log Edits</button>-->
    <nb-button-group *ngIf="!showEdit && (!isSaveDisabled() || isSaving )" status="scaffold" class="pull-right">
      <button nbButton status="scaffold" [nbSpinner]="isSaving" nbSpinnerStatus="basic" [nbTooltip]="'Save ' + itemsService.getGlobalData()" (click)='save()'><nb-icon pack="fas" icon="save"></nb-icon> <span>{{'save'|translation}}</span></button>
      <button status="scaffold" nbButton title="Save Menu" [nbContextMenu]="savemenu" [nbContextMenuTag]="identifier"><nb-icon pack="fas" icon="chevron-down"></nb-icon></button>

    </nb-button-group>
    <nb-button-group status="scaffold" class="pull-right" *ngIf="!showEdit && this.type =='courses' && !isSyncDisabled() && (instanceDetails?.scaffoldType && instanceDetails?.scaffoldType!=='ai-detection')">
       <button
            class="pull-right"
              status="scaffold"
              nbButton
              [nbTooltip]="'push_courses_or_any_changes_from_scaffold_to_lms'|translation"              
              [nbSpinner]="syncing" nbSpinnerStatus="primary"
              [disable]="syncing" (click)='push()'
              >
        <span *ngIf="!syncing"><nb-icon pack="fas" icon="sync"></nb-icon> {{'sync_to_lms'|translation|translationFromString | transformText :'capitalize'}}</span><span *ngIf="syncing"><span>{{syncing}}</span></span>
      </button>
      <button 
              status="scaffold"
              nbButton
              *ngIf="instanceDetails?.scaffoldType==='archivev2'"
              [nbContextMenu]="syncmenu"
              [nbContextMenuTag]="identifier"
              ><nb-icon [nbTooltip]="'attempt_to_restore_course_deleted_in_lms'|translation" pack="fas" icon="chevron-down"></nb-icon></button>
    </nb-button-group>
    <button class="pull-right"
            nbButton
            status="scaffold"
            title="{{'push_update_of_changes_from_parent_course_to_children'|translation}}"
            *ngIf="!showEdit && this.type =='courses' && view.child_courses && view.child_courses.length > 0 && !syncingChild && !isSyncDisabled()"
            [disable]="syncing"
            [nbSpinner]="syncingChild" nbSpinnerStatus="basic"
            [nbContextMenu]="menu"
            [nbContextMenuTag]="identifier">
      <span *ngIf="!syncingChild"><nb-icon pack="fas" icon="sync"></nb-icon>{{'update_children'|translation|translationFromString | transformText :'capitalize'}}</span><span *ngIf="syncingChild"><span>{{syncingChild}}</span></span>update_children
    </button>
    <!--NEBULAR TODO-->
    <button class="pull-right"  nbButton
     [nbTooltip]="'toggle_version_panel'|translation" status="scaffold" *ngIf="!showEdit && this.type =='courses' && instanceDetails?.scaffoldType==='designer'" (click)='toggleVersion()'>{{'versions'|translation}}</button>

    <!--<button nbButton status="info" *ngIf=" !showEdit" (click)='log()'>LOG</button>-->
    <button class="pull-right" nbButton status="scaffold"  routerLink='edit' *ngIf="showEdit">{{'edit'|translation}}</button>
    <button class="pull-right" nbButton status="scaffold"  (click)="updateOverrideView()" *ngIf="overriddenView">{{'pull_latest'|translation}}</button>

  </div>
  <div class="align-center fa-2x" *ngIf="view && view.loading">
    <scaffold-loading-animation></scaffold-loading-animation>
  </div>
  <div class="app-view" *ngIf="!htmlContent">
    <app-view *ngIf="view && view?.data" [items]="view?.data?.content" [info]="view" [data]="view_data"></app-view>
  </div>
  <div class="html-view" *ngIf="htmlContent">
    <div [innerHTML]="htmlContent|safeHtml"></div>
  </div>
  <div class="saving-screen-cover">
    <div>
      <p>{{'saving'|translation}}...</p>
      <scaffold-loading-animation></scaffold-loading-animation>
    </div>
  </div>
</div>
<four-o-four *ngIf="notFoundError"></four-o-four>
